/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, {AxiosRequestConfig} from 'axios';
import {Glum} from 'puddleglum';
import {transformToQueryString, PaginatedResponse} from 'puddleglum/utils';

export default class MyProvidersController {
	static async index(
		request: {patient_id?: number | null} = {},
		validationOnly: boolean = false,
		fieldToValidate: string = '',
		config: AxiosRequestConfig = {},
	) {
		return axios.get<
			Array<
				Glum.Models.Provider & {
					last_seen: string;
					booking_requests_count: number;
					price: Glum.Models.Price;
					is_direct_scheduling_enabled: boolean;
				}
			>
		>(`/api/employee/providers?${transformToQueryString(request)}`, {
			headers: {
				Precognition: validationOnly,
				...(fieldToValidate ? {'Precognition-Validate-Only': fieldToValidate} : {}),
			},
			...config,
		});
	}
}
